import {CUSTOM_CANVAS_APP_NATIVE_EVENTS} from '../../constants';
import {updateHTML} from './updateHTML';

/**
 * This function adds an error listener to the script tag that will be executed when the script fails to load.
 * We are mostly expecting scripts to fail loading due to CORS issues.
 */
export const attachOnErrorListenerToScript = ({
  html,
  scriptTag,
  doc,
}: {
  html: string;
  scriptTag: HTMLScriptElement;
  doc: Document;
}) => {
  const newScript = doc.createElement('script');
  Array.from(scriptTag.attributes).forEach((attr) => {
    newScript.setAttribute(attr.name, attr.value);
  });

  // listener in the onerror will be catching ONLY loading/network errors. See more: https://javascript.info/onload-onerror#script-onerror
  // we can't access error details here, so we will just dispatch an event with the src of the script
  newScript.setAttribute(
    'onerror',
    `(function(data) {
        const errorLoadingScriptInCustomCodeEvent = new CustomEvent('${CUSTOM_CANVAS_APP_NATIVE_EVENTS.ERROR_LOADING_SCRIPT_IN_CUSTOM_CODE}', {
          detail: {
            src: data.src,
          }
        });
        window.dispatchEvent(errorLoadingScriptInCustomCodeEvent);
      })(this)`
  );

  // Replace the old script tag with the new one
  return updateHTML(html, scriptTag.src, newScript.outerHTML);
};
